import {trackOriginClick, originClick} from '@aboutyou/legacy-tracking-sdk';
import {useTracking} from '../utils/utils';

export const useTrackOriginClick = () => {
  const {TrackingClient} = useTracking();
  return (origin: originClick) => () => {
    TrackingClient.track(trackOriginClick({origin}));
  };
};
